import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { CreateLeadFormOutput } from "../../../../components/leads/create_lead/utils";
import { LeadWorkflowQuery } from "../../../generated/app-service-gql/graphql";
import { useLeadWorkflow } from "./useLeadWorkflow";

/**
 * Hook which fetches the lead workflow and determines the default stage ID. It will either be
 * the stage ID provided in the defaultValues, or the first stage in the workflow if none is provided.
 * @param defaultValues
 * @param options
 * @returns
 */
export function useDefaultLeadWorkflowStage(
  defaultValues?: Partial<CreateLeadFormOutput>,
  options?: UseQueryOptions<LeadWorkflowQuery, unknown, LeadWorkflowQuery, QueryKey>,
) {
  const { data: workflow, isLoading } = useLeadWorkflow(
    {},
    {
      ...options,
      enabled: !defaultValues?.stageId,
    },
  );

  const defaultStageId = defaultValues?.stageId ?? workflow?.transitions[0].stage.id;
  return {
    defaultStageId,
    isLoading: !defaultValues?.stageId && isLoading,
  };
}
